import connectionTypes from '../connectionTypes';
import damBackendTypes from '../dam/damBackendTypes';
import IAP_DEVICE_FEATURE_CODES from '../iap/iapDeviceFeatureCodes';
import {strCode} from '../strCode';
import deviceTypes from './deviceTypes';

const DEVICE_TYPES_DATA = {
    [deviceTypes.ILUMA_I2_CHARGER]: {
        nameStrCode: strCode.ILUMA_I2_DEVICE_NAME,
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I2,
        holderType: deviceTypes.ILUMA_I2_HOLDER,
        backendType: damBackendTypes.UAM,
        connectionTypes: [connectionTypes.WIFI, connectionTypes.BLE, connectionTypes.CELLULAR],
    },
    [deviceTypes.ILUMA_I2_HOLDER]: {
        nameStrCode: strCode.ILUMA_I2_HOLDER_NAME,
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I2,
        isHolder: true,
        backendType: damBackendTypes.UAM,
    },
    [deviceTypes.ILUMA_I5_CHARGER]: {
        nameStrCode: strCode.ILUMA_I5_DEVICE_NAME,
        holderType: deviceTypes.ILUMA_I5_HOLDER,
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I5,
        backendType: damBackendTypes.UAMF,
        connectionTypes: [connectionTypes.WIFI, connectionTypes.BLE, connectionTypes.SIDEWALK],
    },
    [deviceTypes.ILUMA_I5_HOLDER]: {
        nameStrCode: strCode.ILUMA_I5_HOLDER_NAME,
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I5,
        isHolder: true,
        backendType: damBackendTypes.UAMF,
    },
};

export default DEVICE_TYPES_DATA;
